import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import type { DashboardStatusBreakdownDto } from "@carry/contract";
import { buildPieData } from "./chart-data";
import { pieColor } from "./chart-colors";

/**
 * 当日のステータス別内訳 (円グラフ). 4 区分集約 (未配送/配送中/完了/キャンセル).
 * 全区分 0 件のときは「本日の配送はありません」を表示する.
 */
export function StatusPieChart({ breakdown }: { breakdown: DashboardStatusBreakdownDto }) {
  const data = buildPieData(breakdown);
  return (
    <div className="panel" style={{ padding: "18px 20px" }}>
      <div className="eyebrow" style={{ marginBottom: 4 }}>
        ステータス内訳
      </div>
      <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 16 }}>本日</div>
      {data.length === 0 ? (
        <div
          style={{ fontSize: 12, color: "var(--ink-3)", padding: "40px 0", textAlign: "center" }}
        >
          本日の配送はありません
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius={48} outerRadius={84}>
              {data.map((d) => (
                <Cell key={d.name} fill={pieColor(d.name)} />
              ))}
            </Pie>
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 11 }} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
